import styles from './new-sales-grid.module.scss';
import { useTableConfigHook } from '../../requestUtils';
import { booleanHeader, CreateHeaders, currencyHeader, dateHeader, HeaderSizeEnum, SumRows, TableProductsFilterProps, textHeader } from '@frontend-workspace/react-shared-lib';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { INewSales } from '../../_models/new-sales';
import { WebkuaTable } from '@frontend-workspace/webkua-lib';
import { useTranslation } from 'react-i18next';


/* eslint-disable-next-line */
export interface NewSalesGridProps {
  newSales: INewSales[],
  onDateChange: (dateRange: DateRange<Date> | null) => void,
  dateRange: DateRange<Date>,
  onRefresh: () => void,
  isLoading: boolean,
  productFilter: TableProductsFilterProps
}

export function NewSalesGrid(props: NewSalesGridProps) {
  const { t } = useTranslation();
  const tableConfig = useTableConfigHook("newSalesReport");
  const headers = CreateHeaders([
    textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.MEDIUM),
    textHeader("companyName", t("standard.customerName"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("department", t("standard.department"), HeaderSizeEnum.LARGE),
    textHeader("contractResponsible", t("standard.contractManager"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("sellerName", t("standard.seller"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("licenseNumber", t("standard.licenseNumber"), HeaderSizeEnum.MEDIUM),
    textHeader("type", t("standard.type"), HeaderSizeEnum.LARGE),
    textHeader("interval", t("standard.period"), HeaderSizeEnum.SMALL, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    textHeader("seats", t("standard.numberOfSeats"), HeaderSizeEnum.MEDIUM, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header",
      summary: SumRows
    }),
    textHeader("setupVismaId", t("newSalesGrid.establishmentItem"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("nimbusCode", t("standard.code"), HeaderSizeEnum.SMALL),
    textHeader("productName", t("newSalesGrid.establishmentItemName"), HeaderSizeEnum.EXTRA_LARGE),
    dateHeader("activationDate", t("standard.invoiceDate")),
    currencyHeader("invoiceAmount", t("standard.invoiceCost"), HeaderSizeEnum.LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header",
      summary: SumRows
    }),
    currencyHeader("saleCostPrice", t("newSalesGrid.saleCostPrice"), HeaderSizeEnum.LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header",
      summary: SumRows
    }),
    currencyHeader("saleContributionMargin", t("newSalesGrid.saleContributionMargin"), HeaderSizeEnum.LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header",
      summary: SumRows
    }),
    currencyHeader("recurringPrice", t("standard.recurringPrice"), HeaderSizeEnum.LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header",
      summary: SumRows
    }),
    currencyHeader("recurringCostPrice", t("newSalesGrid.recurringCostPrice"), HeaderSizeEnum.LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header",
      summary: SumRows
    }),
    currencyHeader("recurringContributionMargin", t("newSalesGrid.recurringContributionMargin"), HeaderSizeEnum.LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header",
      summary: SumRows
    }),
    textHeader("productGroup", t("standard.productGroup"), HeaderSizeEnum.EXTRA_LARGE),
    booleanHeader("isDifferentInVisma", t("newSalesGrid.differentInVisma"))
  ]);

  return (
    <WebkuaTable
      onRefresh={props.onRefresh}
      isLoading={props.isLoading}
      headers={headers}
      data={props.newSales}
      tableConfig={tableConfig}
      dateRange={props.dateRange}
      productsFilter={props.productFilter}
      onSetDateRange={props.onDateChange}
    />
  );
}

export default NewSalesGrid;